import React from 'react';
import urlparser from 'urlparser';
import { default as api, trialDetail } from '../../services/api';
import { InvitePage } from '../InvitePage';
import { Activity358 } from '../Activity358';
import { WeChat } from '../Wechat';
import { WeChatError } from '../Wechat-Error';
import { WeChatSuccess } from '../Wechat-Success';
import OverseasSharing from '../OverseasSharing';
import Fail from '../OverseasSharing/Fail';
import Success from '../OverseasSharing/Success';
import Warning from '../OverseasSharing/Warning';
import { EnglishInvitePage } from '../EnglishInvitePage';
import { CampaignPage } from '../CampaignPage';
import { Route, Router } from 'react-router-dom';
import { RecruitmentPage } from '../RecruitmentPage';
import { WrongPage } from '../WrongPage';
import ReactGA from 'react-ga';
import { ContentShareRegister } from '../Content-Share-Register';
import { VankePage } from '../Vanke';
import { InviteSFPage } from '../InviteSFPage';
import PCModal from '../PCModal';
import { NewInvitePage } from '../NewInvitePage';
import { NewTrialMobilePage } from '../NewTrialMobilePage';
import NewTrialPCPage  from '../NewTrialPCPage';
import {YearPage}  from '../YearPage';

export class IndexPage extends React.Component {
  state = {
    template: '',
    logo: '',
    qrcode: '',
    recordShare: '',
    showQrCode: '',
    inviterId: '',
    trailId: '',
    userId: '',
    error: '',
    contentId: '',
    activityTime: {},
    privilegesDays: '',
    description: '',
    source: '',
    userRegisterType: '',
    state:'',
    utm_source:'',
    utm_campaign:'',
    utm_medium:''
  };
  componentWillMount() {
    let url = window.location.pathname + window.location.search;
    if (url =='/find/activity?redirect_id=11&state=65ebaa601921630a636201c50f9db5cf') {
      window.location.href = window.location.origin + `/trial/482?state=c1cc768701882ea8ef65911aa30ecb22`;
    }
  }
  async componentDidMount() {
    let checkResult = this.checkRightUrl();
    if(checkResult){
      let queryParamsUrl = urlparser.parse(window.location.href).query;
      let query = window.location.pathname;
      if (window.location.pathname === '/trial/content/share') {
        window.location.href = window.location.pathname + window.location.search;
      }
      ReactGA.initialize('UA-120859875-1');
      ReactGA.set({ page: window.location.pathname+window.location.search });
      if (query) {
        let params = query.split('/');
        let id = params[params.length - 1];
        let queryParams = queryParamsUrl && (queryParamsUrl.params as any);
        let inviteId = queryParams ? queryParams.inviterId : '';
        let contentId = queryParams ? queryParams.contentId : '';
        let source = queryParams ? queryParams.source : '';
        let recordShare = queryParams ? queryParams.recordShare : '';
        let state = queryParams ? queryParams.state : null;
        let utm_source=queryParams ? queryParams.utm_source : '';
        let utm_campaign=queryParams ? queryParams.utm_campaign : '';
        let utm_medium=queryParams ? queryParams.utm_medium : '';
        let data =
          queryParams && queryParams.template
            ? {}
            : await trialDetail(id, inviteId, state);
        if (data) {
          if (data.body && data.body.template) {
            let url = '';
            let logo = data.body.logo;
            let qrcode = data.body.qrcode || '';
            let showQrCode = data.body.showQrCode || false;
            let activityTime = {
              startAt: data.body.startAt,
              endAt: data.body.endAt,
            };
            let description = data.body.description;
            let privilegesDays = data.body.privilegesDays;
            let userRegisterType = data.body.userRegisterType;
            let paramsData = {
              logo: logo,
              qrcode: qrcode,
              inviterId: queryParams ? queryParams.inviterId : '',
            };
            if (paramsData && JSON.stringify(paramsData) !== '{}') {
              url = '?';
            }
            let template =
              (queryParams && queryParams.template) || data.body.template;
            if (data.error) {
              alert(data.error);
              this.setState({
                error: data.error,
                template: template,
                logo: logo ? logo : '',
                qrcode: qrcode ? qrcode : '',
                source: source,
                recordShare: recordShare,
                showQrCode: showQrCode ? showQrCode : '',
                inviterId: queryParams ? queryParams.inviterId : '',
                userId: queryParams ? queryParams.userId : '',
                trailId: id ? id : '',
                contentId: contentId,
                activityTime: activityTime,
                privilegesDays: privilegesDays,
                description: description,
                userRegisterType: userRegisterType,
                state:state,
                utm_source:utm_source,
                utm_campaign:utm_campaign,
                utm_medium:utm_medium
              });
            } else {
              ReactGA.pageview(window.location.pathname+`/id${id}`+`/${privilegesDays}days`);
              this.setState({
                template: template,
                logo: logo ? logo : '',
                qrcode: qrcode ? qrcode : '',
                source: source,
                recordShare: recordShare,
                showQrCode: showQrCode ? showQrCode : '',
                inviterId: queryParams ? queryParams.inviterId : '',
                userId: queryParams ? queryParams.userId : '',
                trailId: id ? id : '',
                contentId: contentId,
                activityTime: activityTime,
                privilegesDays: privilegesDays,
                description: description,
                userRegisterType: userRegisterType,
                state:state,
                utm_source:utm_source,
                utm_campaign:utm_campaign,
                utm_medium:utm_medium
              });
            }
          } else {
            let template = queryParams && queryParams.template.split('#')[0];
            this.setState({
              template: queryParams && decodeURIComponent(template),
              inviterId: queryParams ? queryParams.inviterId : '',
              userId: queryParams ? queryParams.userId : '',
              trailId: id ? id : '',
              contentId: contentId,
              state:state,
              utm_source:utm_source,
              utm_campaign:utm_campaign,
              utm_medium:utm_medium
            });
          }
        }
      }
    }
  }

  componentWillReceiveProps(nextProps: any, nextContext: any): void {
    if (nextProps !== this.props) {
      ReactGA.set({ page: window.location.pathname + window.location.search });
      ReactGA.pageview(window.location.pathname + window.location.search);
    }
  }

  checkRightUrl = () => {
    let checkUrl = window.location.pathname;
    if (checkUrl.indexOf('trial') !== -1) {
      return true;
    } else {
      return false;
    }
  };
  getRenderComponent = () => {
    const {
      template,
      logo,
      qrcode,
      inviterId,
      trailId,
      userId,
      error,
      contentId,
      activityTime,
      privilegesDays,
      description,
      showQrCode,
      source,
      recordShare,
      userRegisterType,
      state,
      utm_source,
      utm_campaign,
      utm_medium
    } = this.state;
    let checkResult = this.checkRightUrl();
    if (!checkResult) {
      return <WrongPage />;
    }
    let isPC = !/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent);
    switch (template) {
      case '/trial/year':
        return <YearPage
          logo={logo}
          qrcode={showQrCode}
          inviterId={inviterId}
          trailId={trailId}
          privilegesDays={privilegesDays}
          activityTime={activityTime}
          description={description}
          userRegisterType={userRegisterType}
          state={state}
        />;
      case '/trial/newH5Activity':
        if(!isPC){
          if(utm_source&&utm_campaign&&utm_medium){
            window.location.href=window.location.host=='web.islide.cc'?`https://app.islide.cc/home?trialId=${trailId}&days=${privilegesDays}&utm_campaign=${utm_campaign}&utm_medium=${utm_medium}&utm_source=${utm_source}`:`https://app.b.islide.cc/home?trialId=${trailId}&days=${privilegesDays}&utm_campaign=${utm_campaign}&utm_medium=${utm_medium}&utm_source=${utm_source}`
          }else{
            window.location.href=window.location.host=='web.islide.cc'?`https://app.islide.cc/home?trialId=${trailId}&days=${privilegesDays}`:`https://app.b.islide.cc/home?trialId=${trailId}&days=${privilegesDays}`
          }
          return '正在跳转,请稍等~'
        }
      case '/trial/newActivity':
        return isPC ? (
          <PCModal
            logo={logo}
            inviterId={inviterId}
            qrcode={showQrCode}
            trailId={trailId}
            privilegesDays={privilegesDays}
            activityTime={activityTime}
            description={description}
            userRegisterType={userRegisterType}
            state={state}
          />
        ) : (
          <NewInvitePage
            logo={logo}
            qrcode={showQrCode}
            inviterId={inviterId}
            trailId={trailId}
            privilegesDays={privilegesDays}
            activityTime={activityTime}
            description={description}
            userRegisterType={userRegisterType}
            state={state}
          />
        );
        break;
      case '/trial/newTrial':
        return  isPC ?
        <NewTrialPCPage
        logo={logo}
        qrcode={showQrCode}
        inviterId={inviterId}
        trailId={trailId}
        privilegesDays={privilegesDays}
        activityTime={activityTime}
        description={description}
        userRegisterType={userRegisterType}
        state={state}
      />
        :<NewTrialMobilePage
        logo={logo}
        qrcode={showQrCode}
        inviterId={inviterId}
        trailId={trailId}
        privilegesDays={privilegesDays}
        activityTime={activityTime}
        description={description}
        userRegisterType={userRegisterType}
        state={state}
      />
      case '/trial/activity':
        return (
          <InvitePage logo={logo} inviterId={inviterId} trailId={trailId} state={state} />
        );
        break;
      case '/trial/bookActivity':
        return (
          <InvitePage logo={logo} inviterId={inviterId} trailId={trailId} state={state} />
        );
        break;
      case '/trial/activity-kw':
        return (
          <InvitePage logo={logo} inviterId={inviterId} trailId={trailId} state={state} />
        );
        break;
      case '/trial/activity-358':
        return (
          <Activity358 logo={logo} inviterId={inviterId} trailId={trailId} state={state} />
        );
        break;
      case '/trial/invite':
        return (
          <InvitePage logo={logo} inviterId={inviterId} trailId={trailId} state={state}/>
        );
        break;
      case '/trial/wechat':
        return (
          <WeChat
            logo={logo}
            inviterId={inviterId}
            trailId={trailId}
            state={state}
            qrcode={showQrCode ? qrcode : ''}
          />
        );
        break;
      case '/trial/wechat/fail':
        return (
          <WeChatError
            logo={logo}
            inviterId={inviterId}
            trailId={trailId}
            qrcode={showQrCode ? qrcode : ''}
            error={error}
          />
        );
        break;
      case '/trial/wechat/success':
        return (
          <WeChatSuccess
            logo={logo}
            inviterId={inviterId}
            trailId={trailId}
            state={state}
            qrcode={showQrCode ? qrcode : ''}
          />
        );
        break;
      case '/trial/facebook-share':
        return <OverseasSharing trailId={trailId} userId={userId} state={state} />;
        break;
      case '/trial/facebook-share/fail':
        return <Fail />;
        break;
      case '/trial/facebook-share/success':
        return <Success />;
        break;
      case '/trial/facebook-share/warning':
        return <Warning />;
        break;
      case '/trial/en/campaign_auslogics':
        return (
          <EnglishInvitePage
            logo={logo}
            inviterId={inviterId}
            trailId={trailId}
            state={state}
          />
        );
        break;
      case '/trial/en/campaign_oidatechtips':
        return (
          <EnglishInvitePage
            logo={logo}
            inviterId={inviterId}
            trailId={trailId}
            state={state}
          />
        );
        break;
      case '/trial/en/campaign_etechgeeks':
        return (
          <EnglishInvitePage
            logo={logo}
            inviterId={inviterId}
            trailId={trailId}
            state={state}
          />
        );
        break;
      case '/trial/en/campaign_giveawayoftheday':
        return (
          <CampaignPage logo={logo} inviterId={inviterId} trailId={trailId} state={state} />
        );
        break;
      case '/recruitment':
        return <RecruitmentPage />;
        break;
      case '/trial/vanke':
        return (
          <VankePage
            logo={logo}
            inviterId={inviterId}
            trailId={trailId}
            qrcode={showQrCode ? qrcode : ''}
            state={state}
          />
        );
        break;
      case '/trial/content-share/register':
        return (
          <ContentShareRegister
            logo={logo}
            inviterId={inviterId}
            contentId={contentId}
            trailId={trailId}
            qrcode={showQrCode ? qrcode : ''}
            recordShare={recordShare}
            source={source}
            state={state}
          />
        );
        break;
      case '/trial/activity-sf':
        return (
          <InviteSFPage logo={logo} inviterId={inviterId} trailId={trailId} state={state} />
        );
        break;
      default:
        return null;
        break;
    }
  };

  render() {
    let url = window.location.pathname + window.location.search;
    let checkResult = this.checkRightUrl();
    return !checkResult&&url=='/find/activity?redirect_id=11&state=65ebaa601921630a636201c50f9db5cf'?null:this.getRenderComponent();
  }
}
